interface IIssuers {
  publicKeys: string[];
  nameSpaces: string[];
}

// inital state
const Issuers: IIssuers = {
  publicKeys: ['96B9EC1E4C097C8A42C157556B6565B9118E8847515A4534354857AED3E67AA1'],
  nameSpaces: [],
};

// getters
const getters = {
  getPublicKeys: ( state: IIssuers ) => state.publicKeys,
  getNameSpaces: ( state: IIssuers ) => state.nameSpaces,
};

// mutations
const mutations = {
};

// actions
const actions = {
};

export default {
  state: Issuers,
  getters,
  actions,
  mutations,
};
